import { Empty, Space, Typography } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { useState } from 'react';

import box from '../../assets/img/fi_box_blue.svg';
import PPResizableTable from '../../components/table/PPResizableTable';
import { useTableFilter } from '../../utils/Filter';
import { getIndexColumn } from '../../utils/getIndexColumn';
import './Order.less';

const { Text } = Typography;

const DEFAULT_PAGE_SIZE = 10;

/** Хоосон утгыг "-" болгож харуулна (0 нь бодит утга тул хэвээр) */
const val = (value) => (value === null || value === undefined || value === '' ? '-' : value);

/** Огноог уншигдахуйц болгоно */
const formatDate = (value) => (dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD') : '-');

const getColumns = (getColumnSearchProps, pagination) => [
  getIndexColumn(pagination.current, pagination.pageSize),
  {
    title: 'Агуулах',
    dataIndex: 'warehouseName',
    key: 'warehouseName',
    width: 220,
    ...getColumnSearchProps('warehouseName', 'Агуулах'),
    render: (value) => val(value),
  },
  {
    title: 'Поддон',
    dataIndex: 'shelf',
    key: 'shelf',
    width: 140,
    render: (value) => val(value),
  },
  {
    title: 'Бин',
    dataIndex: 'bin',
    key: 'bin',
    width: 140,
    render: (value) => val(value),
  },
  {
    title: 'Тавиур',
    dataIndex: 'pallet',
    key: 'pallet',
    width: 140,
    render: (value) => val(value),
  },
  {
    title: 'Үүссэн огноо',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 160,
    render: formatDate,
  },
];

/** Тавиурын таб — Тооллогын табтай ижил хүснэгт, шүүлтүүр, зайтай */
const PalletListItem = () => {
  const [docs, setDocs] = useState([]);
  // Эхний ачаалалт дуустал "бүртгэл байхгүй" төлөв харагдахаас сэргийлнэ
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0,
  });

  // Тавиурын бүртгэл авах хүсэлт. `tab` нь List.js-ийн табын URL параметр тул
  // шүүлтүүр болгож API руу явуулахгүй.
  const fetchData = async ({ page = 1, pageSize = DEFAULT_PAGE_SIZE, tab, ...filters } = {}) => {
    setLoading(true);
    try {
      const { data } = await axios.post('/api/v1/warehouse/pallet', {
        page,
        pageSize,
        ...filters,
      });
      setDocs(data?.result?.docs ?? []);
      setPagination({
        current: data?.result?.page ?? page,
        pageSize: data?.result?.limit ?? pageSize,
        total: data?.result?.totalDocs ?? 0,
      });
    } catch (error) {
      console.error('fetchPalletList: ', error);
    } finally {
      setLoading(false);
    }
  };

  // Анхны ачаалалт болон шүүлт солигдох үед hook өөрөө fetchData-г дуудна
  const { getColumnSearchProps, handleTableChange, withHighlight, filters } = useTableFilter({
    fetchData,
  });

  const columns = withHighlight(getColumns(getColumnSearchProps, pagination));

  // Шүүлт хийсэн үед хоосон гарвал хүснэгтээ (шүүлтүүрийн хамт) харуулна,
  // эс тэгвээс шүүлтээ цэвэрлэх боломжгүй болно. `tab` нь шүүлт биш.
  const hasFilters = Object.keys(filters).some((key) => key !== 'tab');

  if (!loading && docs.length === 0 && !hasFilters) {
    return (
      <div className="pp_table_wrapper">
        <Empty
          image={box}
          imageStyle={{ height: 60 }}
          style={{ padding: '32px 0' }}
          description={
            <Space direction="vertical" size={4}>
              <Text strong>Тавиурын бүртгэл байхгүй байна</Text>
            </Space>
          }
        />
      </div>
    );
  }

  return (
    <div className="pp_table_wrapper">
      <PPResizableTable
        dataSource={docs}
        columns={columns}
        size="large"
        rowKey={(record, index) => record?._id ?? index}
        loading={loading}
        onChange={handleTableChange}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          showTotal: (total) => `Нийт ${total} илэрц`,
        }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default PalletListItem;
